import Vue from "vue";
import * as VeeValidate from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import ResourceHelper from "@common/globalization/ResourceHelper";
export default function useVeeValidate() {
	Vue.component("validation-provider", VeeValidate.ValidationProvider);
	Vue.component("validation-observer", VeeValidate.ValidationObserver);
	const cult = ResourceHelper.lang();
	let lang = require(`vee-validate/dist/locale/${cult}.json`);
	if (lang) {
		console.log(lang)
		for (const rule of Object.keys(rules)) {
			const message = ResourceHelper.getString(`${rule}Override`, lang.messages[rule]);
			VeeValidate.extend(rule,
			{
				...(<any>rules)[rule], // add the rule
				message: message // add its message
			});
		}
    }
}
